export interface Country {
  code: string
  prefix: string
  flag: string
}

export const countries: Country[] = [
  { code: 'ES', prefix: '+34', flag: '🇪🇸' },
  { code: 'US', prefix: '+1', flag: '🇺🇸' },
  { code: 'CA', prefix: '+1', flag: '🇨🇦' },
  { code: 'MX', prefix: '+52', flag: '🇲🇽' },
  { code: 'FR', prefix: '+33', flag: '🇫🇷' },
  { code: 'DE', prefix: '+49', flag: '🇩🇪' },
  { code: 'IT', prefix: '+39', flag: '🇮🇹' },
  { code: 'JP', prefix: '+81', flag: '🇯🇵' },
  { code: 'CN', prefix: '+86', flag: '🇨🇳' },
  { code: 'BR', prefix: '+55', flag: '🇧🇷' },
  { code: 'GB', prefix: '+44', flag: '🇬🇧' },
  { code: 'RU', prefix: '+7', flag: '🇷🇺' },
  { code: 'IN', prefix: '+91', flag: '🇮🇳' },
  { code: 'AU', prefix: '+61', flag: '🇦🇺' },
  { code: 'KR', prefix: '+82', flag: '🇰🇷' },
  { code: 'AR', prefix: '+54', flag: '🇦🇷' },
  { code: 'CL', prefix: '+56', flag: '🇨🇱' },
  { code: 'CO', prefix: '+57', flag: '🇨🇴' },
  { code: 'EG', prefix: '+20', flag: '🇪🇬' },
  { code: 'SA', prefix: '+966', flag: '🇸🇦' },
  { code: 'TR', prefix: '+90', flag: '🇹🇷' },
  { code: 'SE', prefix: '+46', flag: '🇸🇪' },
  { code: 'NO', prefix: '+47', flag: '🇳🇴' },
  { code: 'FI', prefix: '+358', flag: '🇫🇮' },
  { code: 'DK', prefix: '+45', flag: '🇩🇰' },
  { code: 'NL', prefix: '+31', flag: '🇳🇱' },
  { code: 'BE', prefix: '+32', flag: '🇧🇪' },
  { code: 'CH', prefix: '+41', flag: '🇨🇭' },
]
